import React, { useEffect, useRef } from "react";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import _ from 'lodash'
import './PhoneNumberEditor.css'

export default function PhoneNumberEditor({ value = "", onValueChange, stopEditing, width, language }) {
    const ref = useRef(null);

    // Localization loading
    let localization;
    try {
        localization = language ? require(`../../../utils/localization/${language}.json`) : null;
    } catch (e) {
        localization = null;
    }

    useEffect(() => {
        // Focus the input inside PhoneInput component
        const timeoutId = setTimeout(() => {
            const input = ref.current?.querySelector('input');
            if (input) {
                input.focus();
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    const handleChange = (newValue) => {
        onValueChange("+" + newValue)
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            stopEditing();
        }
        if (event.key === 'Escape') {
            stopEditing(true); // cancel editing
        }
    };

    return (
        <div className="PhoneNumberEditor-wrapper" style={{ minWidth: width }} ref={ref}>
            <PhoneInput
                country="fr"
                localization={localization}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                isValid={(inputNumber, country) => _.startsWith(inputNumber, country.dialCode)}
                onlyCountries={['fr', 'gb', 'es', 'it', 'nl', 'be']}
                specialLabel=""
                inputClass="PhoneNumberEditor-input"
                containerClass="PhoneNumberEditor-container"
                dropdownClass="PhoneNumberEditor-dropdown"
            />
        </div>
    );
}
